import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=ef0bc6b4&scoped=true"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"
import style0 from "./Guides.vue?vue&type=style&index=0&id=ef0bc6b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0bc6b4",
  null
  
)

export default component.exports